// Game content: ingredients, recipes (names inspired by the Flying Saucer menu),
// alien guest species and the campaign levels.

// prep: null | 'chop' | 'grind'
export const INGREDIENTS = {
  tea:       { name: 'Star Tea Leaves',   prep: null,    color: '#3f8f4a', accent: '#a7e07a', shape: 'leaves' },
  mint:      { name: 'Moon Mint',         prep: 'chop',  color: '#35d18a', accent: '#b5ffd8', shape: 'mint' },
  jasmine:   { name: 'Night Jasmine',     prep: null,    color: '#f3f0ff', accent: '#b69cff', shape: 'flower', glow: 0.6 },
  licorice:  { name: 'Licorice Root',     prep: 'chop',  color: '#6b3e25', accent: '#c78a5a', shape: 'root' },
  cinnamon:  { name: 'Comet Cinnamon',    prep: 'grind', color: '#a0522d', accent: '#e39b5c', shape: 'sticks' },
  matcha:    { name: 'Gyokuro Leaves',    prep: 'grind', color: '#6fb33b', accent: '#c8f28a', shape: 'leaves2' },
  cacao:     { name: 'Cosmo Cacao',       prep: 'grind', color: '#5a2e1c', accent: '#d08a5a', shape: 'pod' },
  glow:      { name: 'Glow Jelly',        prep: null,    color: '#61f7ff', accent: '#e0fdff', shape: 'jelly', glow: 3.0 },
  dryice:    { name: 'Dry Ice',           prep: null,    color: '#d8ecff', accent: '#ffffff', shape: 'cube', glow: 0.15 },
  nutcream:  { name: 'Nut Cream',         prep: null,    color: '#f2e2c4', accent: '#c79a62', shape: 'jar' },
  salt:      { name: 'Star Salt',         prep: null,    color: '#ffc2e6', accent: '#ffffff', shape: 'crystals', glow: 0.4 },
  coconut:   { name: 'Coconut',           prep: 'chop',  color: '#7a4b2a', accent: '#fffaf0', shape: 'coconut' },
  aloe:      { name: 'Aloe Vera',         prep: 'chop',  color: '#5fbf6a', accent: '#d9ffd9', shape: 'aloe' },
  mango:     { name: 'Mango',             prep: 'chop',  color: '#ffae2b', accent: '#ff6a3d', shape: 'mango' },
  banana:    { name: 'Banana',            prep: 'chop',  color: '#ffe14a', accent: '#8a6a1a', shape: 'banana' },
  pineapple: { name: 'Pineapple',         prep: 'chop',  color: '#ffc93b', accent: '#3aa35a', shape: 'pineapple' },
  passion:   { name: 'Passion Fruit',     prep: 'chop',  color: '#7b2a78', accent: '#ffd23f', shape: 'orb' },
  goji:      { name: 'Goji Berries',      prep: null,    color: '#ff3b3b', accent: '#ff8a5c', shape: 'berries' },
  apple:     { name: 'Apple',             prep: 'chop',  color: '#ff4d5e', accent: '#7ad35b', shape: 'apple' },
  water:     { name: 'Cloudwater',        prep: null,    color: '#8ed8ff', accent: '#ffffff', shape: 'cloud', glow: 0.35 },
  pearls:    { name: 'Boba Pearls',       prep: null,    color: '#3a1f2a', accent: '#8a5a6a', shape: 'pearls' },
};

// appliance: 'kettle' (hot, on a stove, can boil over) | 'blender'
// fizz: must be finished in the Carbonator
// boba: poured into a boba cup with pearls, sealed in the Sealer and finished with a straw
// perk: bonus effect when served
export const RECIPES = {
  jasmine_tea:          { name: 'Jasmine Tea',              app: 'kettle',  ing: ['jasmine', 'water'], color: '#f0e6ff', perk: 'serenity' },
  subtle_tea:           { name: 'Subtle Tea',               app: 'kettle',  ing: ['tea', 'water'], color: '#c9e59a' },
  spiced_tea:           { name: 'Spiced Tea',               app: 'kettle',  ing: ['tea', 'cinnamon', 'water'], color: '#d98a4a' },
  banana_water:         { name: 'Banana Water',             app: 'blender', ing: ['banana', 'water'], color: '#fff39a', perk: 'bonus' },
  pulsar_punch:         { name: 'Pulsar Punch',             app: 'blender', ing: ['mango', 'pineapple', 'water'], color: '#ff4f5a', perk: 'streak' },
  mango_magic:          { name: 'Mango Magic',              app: 'blender', ing: ['mango', 'mango', 'coconut'], color: '#ffa21f' },
  smoothie_star:        { name: 'Smoothie Star',            app: 'blender', ing: ['banana', 'mango', 'nutcream'], color: '#f7c9a0' },
  glowing_green:        { name: 'Glowing Green Smoothie',   app: 'blender', ing: ['glow', 'mint', 'aloe'], color: '#8dff3a', glow: 1 },
  herbal_blend:         { name: 'Herbal Blend',             app: 'kettle',  ing: ['mint', 'licorice', 'water'], color: '#c8a04a' },
  movemint_tea:         { name: 'Movemint Tea',             app: 'kettle',  ing: ['mint', 'tea', 'water'], color: '#5fd6a0' },
  electrolyte_speed:    { name: 'Electrolyte Speed',        app: 'blender', ing: ['salt', 'glow', 'water'], color: '#3ad8ff', glow: 1, perk: 'speed' },
  cryo_comet:           { name: 'Cryo Comet',               app: 'blender', ing: ['dryice', 'coconut', 'water'], color: '#dff4ff', perk: 'freeze' },
  creamy_matcha:        { name: 'Creamy Matcha',            app: 'kettle',  ing: ['matcha', 'nutcream', 'water'], color: '#a8d672' },
  choco_latte:          { name: 'Choco Latte',              app: 'kettle',  ing: ['cacao', 'nutcream', 'water'], color: '#8a5a3a' },
  luminous_soup:        { name: 'Luminous Soup',            app: 'kettle',  ing: ['glow', 'glow', 'water'], color: '#40e0ff', glow: 1.5, perk: 'tips' },
  martian_mist:         { name: 'Martian Mist',             app: 'blender', ing: ['nutcream', 'cinnamon', 'dryice', 'water'], color: '#ffb0a0', perk: 'drone' },
  veracity_serum:       { name: 'Veracity Serum',           app: 'blender', ing: ['aloe', 'water'], fizz: true, color: '#b6ff5a', perk: 'patience' },
  sparkle_spray:        { name: 'Sparkle Spray',            app: 'blender', ing: ['glow', 'dryice'], fizz: true, color: '#e0f8ff', glow: 1.2 },
  outer_rimjob:         { name: 'Outer Rimjob',             app: 'blender', ing: ['pineapple', 'coconut', 'salt'], fizz: true, color: '#ffe07a' },
  bliss_bubbler:        { name: 'Bliss Bubbler',            app: 'blender', ing: ['passion', 'jasmine', 'water'], fizz: true, color: '#e59ae6' },
  comet_mint:           { name: 'Comet Mint',               app: 'blender', ing: ['mint', 'dryice', 'water'], fizz: true, color: '#6fffd8' },
  moonfire_oolong:      { name: 'Moonfire Oolong',          app: 'kettle',  ing: ['tea', 'glow', 'cinnamon', 'water'], color: '#ff6a2a', glow: 0.8 },
  licorice_elixir:      { name: 'Licorice Elixir',          app: 'kettle',  ing: ['licorice', 'cinnamon', 'water'], color: '#5a3020', perk: 'calm' },
  supernova:            { name: 'Supernova',                app: 'blender', ing: ['mango', 'dryice', 'water'], fizz: true, color: '#ffcf5a', glow: 0.6 },
  jupiter_drop:         { name: 'Jupiter Drop',             app: 'blender', ing: ['passion', 'pineapple', 'dryice'], color: '#c0508a' },
  nutty_nightcap:       { name: 'Nutty Nightcap',           app: 'kettle',  ing: ['nutcream', 'cinnamon', 'licorice'], color: '#c9a27a' },
  void_bloom:           { name: 'Void Bloom',               app: 'blender', ing: ['jasmine', 'mango', 'glow'], color: '#8a5cff', glow: 1 },
  hypna_goji:           { name: 'Hypna Goji',               app: 'blender', ing: ['goji', 'goji', 'glow'], color: '#ff4a8a', glow: 0.8 },
  glow_job:             { name: 'Glow Job',                 app: 'blender', ing: ['glow', 'pineapple', 'water'], fizz: true, color: '#c8ff5a', glow: 1.4 },
  liminalade:           { name: 'Liminalade',               app: 'blender', ing: ['aloe', 'mint', 'water'], fizz: true, color: '#a8ffe0' },
  melting_gas:          { name: 'Melting Gas',              app: 'blender', ing: ['dryice', 'salt', 'glow'], fizz: true, color: '#d0c0ff', glow: 1 },
  inner_chi:            { name: 'Inner Chi Drink',          app: 'kettle',  ing: ['tea', 'goji', 'water'], color: '#ff9a7a' },
  cosmic_colada:        { name: 'Cosmic Colada',            app: 'blender', ing: ['pineapple', 'coconut', 'nutcream'], color: '#fff6d8' },
  naughty_draught:      { name: 'Naughty Draught',          app: 'blender', ing: ['cinnamon', 'nutcream', 'pineapple'], color: '#e8b070', perk: 'bonus' },
  cosmic_compassion:    { name: 'Cosmic Compassion',        app: 'blender', ing: ['passion', 'nutcream', 'water'], color: '#d890f0' },
  nebula_nectar:        { name: 'Nebula Nectar',            app: 'blender', ing: ['goji', 'nutcream', 'water'], color: '#ff5a78' },
  enlightened_mint:     { name: 'Enlightened Mint Smoothie', app: 'blender', ing: ['mint', 'banana', 'nutcream'], color: '#c8ffb0' },
  bliss_drink:          { name: 'Bliss Drink',              app: 'blender', ing: ['passion', 'mango', 'water'], color: '#ff7a2a' },
  lifting_spirit:       { name: 'Lifting Spirit',           app: 'kettle',  ing: ['licorice', 'jasmine', 'water'], color: '#d8c0ff', perk: 'serenity' },
  blossom_blast:        { name: 'Blossom Blast',            app: 'blender', ing: ['jasmine', 'mango', 'banana', 'water'], color: '#ffb6d9', perk: 'boost' },
  power_sip:            { name: 'Power Sip',                app: 'blender', ing: ['banana', 'goji', 'salt'], color: '#ff3a3a', perk: 'speed' },
  upbeat_rhythm:        { name: 'Upbeat Rhythm',            app: 'blender', ing: ['apple', 'mint', 'glow'], color: '#a0ff8a', glow: 0.8, perk: 'streak' },
  appletizer:           { name: 'Appletizer',               app: 'blender', ing: ['apple', 'apple', 'water'], fizz: true, color: '#ffe58a' },
  serendipity_dip:      { name: 'Serendipity Dip',          app: 'blender', ing: ['apple', 'cacao', 'nutcream'], color: '#b07850' },
  condensed_cloudwater: { name: 'Condensed Cloudwater',     app: 'kettle',  ing: ['water', 'water', 'dryice'], color: '#e8f8ff', perk: 'freeze' },
  cosmic_milk_tea:      { name: 'Cosmic Milk Tea',          app: 'kettle',  ing: ['tea', 'nutcream', 'water'], boba: true, color: '#c99a6c' },
  jasmine_pearl:        { name: 'Jasmine Pearl Tea',        app: 'kettle',  ing: ['jasmine', 'nutcream', 'water'], boba: true, color: '#f1e2c6', perk: 'serenity' },
  matcha_meteor:        { name: 'Matcha Meteor',            app: 'kettle',  ing: ['matcha', 'water'], boba: true, color: '#8cc85a', perk: 'freeze' },
  mango_moon_boba:      { name: 'Mango Moon Boba',          app: 'blender', ing: ['mango', 'nutcream', 'water'], boba: true, color: '#ffbe55', perk: 'tips' },
};
for (const k in RECIPES) RECIPES[k].id = k;
for (const k in INGREDIENTS) INGREDIENTS[k].id = k;

export const SLUDGE = { id: 'sludge', name: 'Murky Sludge', color: '#4a4a3a' };

export const PERKS = {
  serenity: { icon: '☾', name: 'Serenity', desc: 'Guests who arrive in the next 20s are 35% more patient', short: 'New guests +35% patience', dur: 20, color: '#c9b6ff' },
  bonus: { icon: '✦', name: 'Cheeky Tip', desc: '+25 coins go straight into the till', short: '+25 coins', dur: 0, color: '#ffd35a' },
  streak: { icon: '⚡', name: 'Pulsar Pulse', desc: 'Your tip multiplier jumps up a level (up to ×4)', short: 'Tip multiplier +1', dur: 0, color: '#ff9d3b' },
  speed: { icon: '»', name: 'Electrolyte Rush', desc: 'Every chef moves 40% faster for 15s', short: 'Chefs 40% faster', dur: 15, color: '#7ef7ff' },
  freeze: { icon: '❄', name: 'Cryo Stasis', desc: 'Waiting guests\' patience stops draining for 10s', short: 'Patience frozen', dur: 10, color: '#bfe8ff' },
  tips: { icon: '✧', name: 'Luminous Tips', desc: 'Every tip is doubled for 20s', short: 'Tips ×2', dur: 20, color: '#9ffcff' },
  drone: { icon: '⟳', name: 'Cleaning Drone', desc: 'Every dirty cup is washed and sent back to the rack', short: 'All cups washed', dur: 0, color: '#ffb0a0' },
  patience: { icon: '♥', name: 'Truth Serum', desc: 'Every waiting guest gets 40% of their patience back', short: 'Patience +40%', dur: 0, color: '#c8ffcf' },
  calm: { icon: '☁', name: 'Ethereal Calm', desc: 'All fires go out and nothing can catch fire for 15s', short: 'Fireproof kitchen', dur: 15, color: '#d0a080' },
  boost: { icon: '✿', name: 'Blossom Boost', desc: 'Kettles and blenders work twice as fast for 15s', short: 'Brewing ×2', dur: 15, color: '#ffb6d9' },
};

export const SPECIES = [
  { id: 'glorb', name: 'Glorb', patience: 1.0, tip: 1.0, color: '#6dff8a', color2: '#1f9a5a' },
  { id: 'zeeb', name: 'Zeeb', patience: 0.9, tip: 1.2, color: '#b58cff', color2: '#5a2fb0' },
  { id: 'nuvari', name: 'Nuvari', patience: 1.15, tip: 1.0, color: '#ff8ad8', color2: '#9a2f8a' },
  { id: 'krix', name: 'Krix', patience: 0.8, tip: 1.4, color: '#ff9a4a', color2: '#9a4a1f' },
  { id: 'moff', name: 'Moff', patience: 1.25, tip: 0.9, color: '#ffe9b8', color2: '#b8905a' },
];

export const CHEF_COLORS = ['#3ee6d0', '#ff6fa8', '#ffc94a', '#a98bff'];
export const CHEF_NAMES = ['Nova', 'Pip', 'Zuzu', 'Orbi'];
/** Someone watching instead of cooking has no chef colour of their own: their Delegate wheel and "yours" rings glow in this. */
export const SPECTATOR_COLOR = '#e6e0ff';

/*
 Map legend
   ~ lounge floor      g guest seat        T bar counter (serve here)
   . kitchen floor     # counter           W wall / planter      ' ' open space (void)
   K stove + kettle    k stove             B blender + jug       b blender base
   C chopping board    G grinder           S sink                R cup rack
   X recycler (bin)    Z carbonator        E extinguisher        H supply chute
   D boba cup stack    V cup sealer        Y straw holder
   > < ^ | conveyor    @ & teleporter pair = retracting bridge   1-4 chef spawns
   lowercase letters -> ingredient crates via level.crates
*/
export const LEVELS = [
  {
    id: 'first-contact', name: 'First Contact', sub: 'Docking Ring Tearoom', twist: 'none',
    twistText: 'Welcome aboard! Brew Subtle Tea in a kettle, pour it into a clean cup and serve it at the bar. Wash dirty cups in the sink.',
    time: 180, recipes: ['subtle_tea'], stars: [300, 500, 700],
    spawn: 20, cups: 5, maxGuests: 3,
    crates: { t: 'tea', w: 'water' },
    map: [
      '~~~g~~g~~g~~~',
      '###T##T##T#R#',
      '#...........S',
      't..1.###.2..#',
      '#....#K#....#',
      'w...........X',
      '##K##E####K##',
    ],
    theme: { neb1: '#3b1f7a', neb2: '#2ec8e0', neb3: '#ff7ab8', planet: '#6a4fc0', planet2: '#f5a3cf', accent: '#ffb86b', accent2: '#6ad8ff', floor: '#2a2346', counter: '#e9e3f5', wood: '#b07a52', seed: 1.3 },
    pos: [0.12, 0.72],
  },
  {
    id: 'orchard-moon', name: 'Orchard Moon', sub: 'Hydroponic Juice Deck', twist: 'none',
    twistText: 'New: fruit! Chop bananas on the board, then whirl them in a blender for Banana Water. Blenders never burn.',
    time: 200, recipes: ['subtle_tea', 'banana_water'], stars: [300, 500, 700],
    spawn: 17, cups: 6, maxGuests: 4,
    crates: { n: 'banana', w: 'water', t: 'tea' },
    map: [
      '~~g~~g~~g~~g~~',
      '##T##T##T##TR#',
      '#............S',
      'n..1..#CC#.2.#',
      '#.....#..#...#',
      '#............#',
      '#...#BBEK#...X',
      'w............#',
      '#t############',
    ],
    theme: { neb1: '#1f5a3a', neb2: '#ffb347', neb3: '#ff6a8a', planet: '#3a8a4a', planet2: '#ffd27a', accent: '#ffcf5a', accent2: '#7dffb0', floor: '#23343a', counter: '#f3efe2', wood: '#9a6a3a', seed: 2.7 },
    pos: [0.24, 0.45],
  },
  {
    id: 'conveyor-nebula', name: 'Conveyor Nebula', sub: 'Cargo Bay Café', twist: 'conveyor',
    twistText: 'New: the cargo belt. Star Salt and Glow Jelly ride in on it: grab them for Electrolyte Speed.',
    time: 210, recipes: ['subtle_tea', 'banana_water', 'electrolyte_speed'], stars: [300, 500, 700],
    spawn: 16, cups: 6, maxGuests: 4,
    crates: { n: 'banana', t: 'tea', w: 'water' },
    chute: ['glow', 'salt'],
    view: { rows: 9, shift: 0.3 }, // keep the belt clear of the controls bar along the bottom
    map: [
      '~~~g~~~g~~~g~~g~',
      '###T###T###T##T#',
      'n..............S',
      'X..1..#CC#..2..R',
      't.....#KKE.....#',
      'w..#BB#..#KB#..#',
      '#..............#',
      'H>>>>>>>>>>>>>>#',
    ],
    theme: { neb1: '#1a2a6a', neb2: '#61f7ff', neb3: '#9a6aff', planet: '#2a4a9a', planet2: '#8ad8ff', accent: '#61f7ff', accent2: '#ff9a4a', floor: '#1e2438', counter: '#dfe6f2', wood: '#7a6a8a', seed: 4.1 },
    pos: [0.38, 0.68],
  },
  {
    id: 'boba-orbit', name: 'Boba Orbit', sub: 'Bubble Tea Terrace', twist: 'boba',
    twistText: 'New: boba! Scoop pearls into a boba cup, pour in Cosmic Milk Tea, seal it in the Sealer, then stab in a straw. Boba cups are disposable, so there is no washing up.',
    time: 210, recipes: ['cosmic_milk_tea'], stars: [300, 500, 700],
    spawn: 17, cups: 0, maxGuests: 4,
    crates: { p: 'pearls', t: 'tea', u: 'nutcream', w: 'water' },
    map: [
      '~~g~~~g~~~g~~~g~',
      '##T#D#T#V#T#Y#T#',
      'p..............#',
      't..1.........2.#',
      '#....##KK#.....X',
      'u....###K#.....w',
      '#..............#',
      '#######E########',
    ],
    theme: { neb1: '#4a1a6a', neb2: '#ff7a5a', neb3: '#5ad0ff', planet: '#8a3a5a', planet2: '#ffb08a', accent: '#ff8a6a', accent2: '#b08aff', floor: '#2a1e38', counter: '#f0e6ee', wood: '#8a5a6a', seed: 5.9 },
    pos: [0.5, 0.4],
  },
  {
    id: 'fizz-station', name: 'Twin Hulls', sub: 'Two-Deck Boba Bar', twist: 'teleport',
    twistText: 'New: two hulls, one crew. Hop the teleporters, or pass things over the counters in the middle wall. Jasmine Pearl Tea joins the menu.',
    time: 220, recipes: ['cosmic_milk_tea', 'jasmine_pearl'], stars: [300, 500, 700],
    spawn: 17, cups: 0, maxGuests: 4,
    crates: { t: 'tea', w: 'water', j: 'jasmine', u: 'nutcream', o: 'pearls' },
    map: [
      '~~g~~~g~~~g~~~g~~',
      '##T###T#W#T#Y#T##',
      't.......W.......#',
      'w..1....#.....2.D',
      'j....@..W..@....o',
      'u...KK..#..V##..#',
      '#.......W.......#',
      '#####E##W######X#',
    ],
    theme: { neb1: '#0a3a5a', neb2: '#7affd8', neb3: '#ff5ad0', planet: '#1a6a8a', planet2: '#aaffea', accent: '#7affd8', accent2: '#ff7ad8', floor: '#1a2a36', counter: '#e6f4f2', wood: '#5a8a8a', seed: 7.2 },
    pos: [0.62, 0.66],
  },
  {
    id: 'solar-flare', name: 'Solar Flare', sub: 'Sunward Observation Deck', twist: 'flare',
    twistText: 'New: solar flares set stations on fire! Grab a Cryo Extinguisher and hold Use to put them out. Jupiter Drop comes back to the menu.',
    time: 220, recipes: ['cosmic_milk_tea', 'jasmine_pearl', 'jupiter_drop'], stars: [300, 500, 700],
    spawn: 18, cups: 7, maxGuests: 4,
    crates: { t: 'tea', j: 'jasmine', u: 'nutcream', w: 'water', o: 'pearls', f: 'passion', p: 'pineapple', d: 'dryice' },
    map: [
      '~~~g~~~g~~~g~~~g~',
      '###T###T#D#T#SRT#',
      't...............#',
      'j..1....E....2..#',
      'u...#KKK#VC#....o',
      'w...............f',
      'Y...#BB###C#E...p',
      '#...............d',
      '########X########',
    ],
    theme: { neb1: '#6a2a0a', neb2: '#ffb030', neb3: '#ff3a5a', planet: '#9a3a1a', planet2: '#ffcf6a', accent: '#ffb030', accent2: '#ff5a3a', floor: '#2e1e1e', counter: '#f5ebe0', wood: '#9a5a3a', seed: 8.8, sun: true },
    pos: [0.74, 0.42],
  },
  {
    id: 'eclipse', name: 'Eclipse Lounge', sub: 'Dark Side Speakeasy', twist: 'blackout',
    twistText: 'New: eclipses plunge the lounge into darkness. Glowing ingredients and your helmet lamps light the way.',
    time: 220, recipes: ['cosmic_milk_tea', 'jasmine_pearl', 'void_bloom', 'inner_chi'], stars: [300, 500, 700],
    spawn: 17, cups: 7, maxGuests: 4,
    crates: { j: 'jasmine', m: 'mango', y: 'glow', q: 'goji', o: 'pearls', w: 'water', u: 'nutcream', t: 'tea' },
    map: [
      '~~g~~~g~~~~g~~~g~~',
      '##T###T#DV#T#SRT##',
      'j................#',
      'm..1....##....2..y',
      'q...BB..KK..BB...o',
      'w................u',
      '#...CC..KK..C....#',
      '#................t',
      '####X####E###Y####',
    ],
    theme: { neb1: '#1a0a3a', neb2: '#8a5cff', neb3: '#ff4a8a', planet: '#1a1030', planet2: '#5a3a9a', accent: '#b08aff', accent2: '#ff5aa8', floor: '#18142a', counter: '#e2dcf0', wood: '#5a4a7a', seed: 10.4 },
    pos: [0.84, 0.7],
  },
  {
    id: 'cosmic-crossing', name: 'Cosmic Crossing', sub: 'Split-Deck Smoothie Club', twist: 'bridge',
    twistText: 'New: the saucer decks drift apart! Cross the bridges while they are out, or pass things over the middle counter (the Sealer sits there).',
    time: 230, recipes: ['jasmine_pearl', 'mango_moon_boba', 'bliss_drink', 'cosmic_compassion'], stars: [300, 500, 700],
    spawn: 17, cups: 7, maxGuests: 4,
    crates: { o: 'pearls', u: 'nutcream', f: 'passion', w: 'water', m: 'mango', j: 'jasmine' },
    map: [
      '~~g~~~g~~~g~~~g~~',
      '##T###T#D#T#SRT##',
      '#...............#',
      'X..1.#BBBKBE..2.#',
      '#...............#',
      '  ==  #CVC#  ==  ',
      '#...............#',
      'Y...............u',
      'o...............f',
      '###w#######m###j#',
    ],
    theme: { neb1: '#0a1a4a', neb2: '#ff8ad8', neb3: '#5affc8', planet: '#3a2a8a', planet2: '#ff9ad0', accent: '#ff8ad8', accent2: '#5affc8', floor: '#1c1a34', counter: '#ede6f8', wood: '#6a5a9a', seed: 12.2 },
    pos: [0.91, 0.45],
  },
  {
    id: 'stardust-gala', name: 'Stardust Gala', sub: 'The Grand Saucer Ballroom', twist: 'gala',
    twistText: 'The finale! Solar flares AND eclipses on the busiest night in the galaxy, with drinks you already know.',
    time: 240, recipes: ['cosmic_milk_tea', 'jasmine_pearl', 'mango_moon_boba', 'blossom_blast', 'power_sip'], stars: [300, 500, 700],
    spawn: 15, cups: 8, maxGuests: 5,
    crates: { j: 'jasmine', m: 'mango', n: 'banana', w: 'water', q: 'goji', s: 'salt', t: 'tea', o: 'pearls', u: 'nutcream' },
    map: [
      '~~g~~~g~~~g~~~g~~~g~',
      '##T###T#D#T#SRT#Y#T#',
      'j..................#',
      'm..1..#BBB##BBB..2.t',
      'n..................o',
      'w..E..#CCK##KVK..E.u',
      'q..................#',
      '#s########X#########',
    ],
    theme: { neb1: '#3a0a5a', neb2: '#ffd35a', neb3: '#ff5ab0', planet: '#6a2a9a', planet2: '#ffd9a0', accent: '#ffd35a', accent2: '#ff7ad8', floor: '#221a36', counter: '#f6eee0', wood: '#a07a4a', seed: 14.6, sun: true },
    pos: [0.78, 0.13],
  },
];

export function recipeIngredientsKey(ings) {
  return ings.slice().sort().join('+');
}
const recipeIndex = {};
for (const k in RECIPES) {
  const r = RECIPES[k];
  recipeIndex[r.app + ':' + recipeIngredientsKey(r.ing)] = k;
}
export function matchRecipe(app, contents) {
  return recipeIndex[app + ':' + recipeIngredientsKey(contents)] || null;
}
/** Recipes (for this appliance) that these contents could still become by adding more. */
export function reachableRecipes(app, contents) {
  const out = [];
  for (const k in RECIPES) {
    const r = RECIPES[k];
    if (r.app !== app || r.ing.length < contents.length) continue;
    const left = r.ing.slice();
    let ok = true;
    for (const id of contents) {
      const i = left.indexOf(id);
      if (i < 0) { ok = false; break; }
      left.splice(i, 1);
    }
    if (ok) out.push({ id: k, missing: left });
  }
  return out;
}
/**
 * Star goals are set for one player (three stars at 700 on every shift). Bigger crews need more, as in
 * Overcooked 2, but a crowded kitchen adds less with each extra chef: 1.6x for two, 2.2x for three, 2.6x for four.
 * Guests arrive faster by the same factor, so the bigger goals stay reachable.
 */
const CREW_SCALE = [1, 1.6, 2.2, 2.6];
export function crewScale(players) {
  return CREW_SCALE[Math.max(1, Math.min(4, players)) - 1];
}
/** A shift clock as m:ss, or h:mm:ss once an infinite shift has run an hour. */
export function clockText(seconds) {
  const s = Math.max(0, Math.floor(seconds)), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = String(s % 60).padStart(2, '0');
  return h ? `${h}:${String(m).padStart(2, '0')}:${ss}` : `${m}:${ss}`;
}
export function starGoals(level, players) {
  return level.stars.map((s) => Math.round((s * crewScale(players)) / 10) * 10);
}